import React, {
  useContext,
  useState,
} from 'react';
import { Button, Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { Control } from 'react-hook-form';
import { LocalizationContext } from '../Localization/LocalizationProvider';
import './Styles.scss';
import ComponentTextInput from '../ComponentTextinput/ComponentTextInput';
import { MainFormValues } from '../../Screens/addCustomer/utils/types';

interface IAddSMCModal {
  show: boolean;
  setOpenFrom : () => void;
  handleSave : (e: string) => void;
  control: Control<MainFormValues>;
  setValue: SetValue;
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: '6px 24px 24px 24px',
  '@media (max-width: 1200px)': {
    width: '95%',
  },
  '@media (max-width: 768px)': {
    width: '95%',
    height: 'auto',
    p: 2,
  },
};
export default function AddAlertModal({
  show, setOpenFrom, handleSave, control, setValue,
}: IAddSMCModal) {
  const { translations } = useContext(LocalizationContext);
  const [alert, setAlert] = useState('');

  const handleClose = () => {
    setAlert('');
    setValue('newAlert', '');
    setOpenFrom();
  };
  const handleAdd = () => {
    handleSave(alert);
    handleClose();
  };

  return (
    <div>
      <Modal
        open={show}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="customerInfo_container flex-row">
            <div className="customerInfo">
              Add Customer Alert Notes
            </div>
            <div onClick={handleClose}>
              <CloseIcon />
            </div>
          </div>
          <Grid item xs={12} sm={12} md={12}>
            <div className="div_label_text alert_field_container">
              <label className="label_Style_Customer">Add New Note</label>
              <ComponentTextInput
                control={control}
                inputProps={{ maxLength: 700 }}
                multiline
                className="nonCapitalizeField"
                handleChange={(_str, val) => {
                  setAlert(val);
                }}
                rowSize={8.8}
                name="newAlert"
                id="newAlert"
                size="small"
              />
            </div>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <div className="save_and_next_div">
              <div>
                <Button className="button_cancel" onClick={handleClose}>{translations.cancel}</Button>
              </div>
              <div className="button_margin_left">
                <Button
                  className="button_save_and_next"
                  disabled={alert.trim().length === 0}
                  onClick={handleAdd}
                >
                  Add
                </Button>
              </div>
            </div>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
